import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Msg, Button, Input } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import * as MobileActions from 'actions/index.ts';
import Util from 'lib/util.js';
import CompanyService from 'services/company2';
import { Redirect } from 'react-router-dom';

import Drawer from '@material-ui/core/Drawer';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TopNav from '../components/topNav.js';
import Divider from '@material-ui/core/Divider';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Fab from '@material-ui/core/Fab';
import Download from 'components/download.js';
import useDetail from 'hooks/useDetail';
import { useState, useEffect, useContext } from 'react';
import { ActionContext } from 'actions/context';
import InquiryService from 'services/inquiry';
import ModalService from 'services/modal';
import Modal from 'components/modal';
import Big from 'big.js';
//单头自定义字段
// import HeadCustField from 'components/headCustField';
import CustFieldService from 'services/custField';
import BodydCustField from 'components/bodyCustField';

function InquiryQuoteDetail(props) {
  const styles = theme => ({
    quoteBt: {
      height: 32,
      borderRadius: '4px'
    },
    expanActions: {
      padding: '6px 24px 6px 8px'
    },
    checkbox: {
      padding: '0px 2px'
    },
    expansionSum: {
      '&$expanded': {
        margin: '12px 0px'
      }
    },
    pb30: {
      paddingBottom: 30
    },
    expanded: {}
  });

  const Config = {
    sale: {
      apiPath: '/inquiry/customerOrder/getDetail',
      apiPathQuoteDetail: '/inquiry/quoteOrder/detail',
      quotePublishApiPath: '/inquiry/quoteOrder/publish',
      enumMainKey: 'B02_Inquiry_Status',
      companyCodeKey: 'customerCode',
      vendorCodeKey: 'companyCode',
      companyNameKey: 'innerCustomerName',
      custFieldBillType: 51, //自定义字段单别
      arrEnumField: [
        {
          mainKey: 'B02_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'inqXkNo',
      quoteName: '报价'
    },
    purchase: {
      apiPath: '/inquiry/Order/getDetail',
      apiPathQuoteDetail: '/inquiry/vendorQuoteOrder/detail',
      companyCodeKey: 'companyCode',
      companyNameKey: 'innerVendorName',
      vendorCodeKey: 'vendorCode',
      custFieldBillType: 51, //自定义字段单别
      detailLink: '/mp/purchase/inquiry/prod/quotation',
      arrEnumField: [
        {
          mainKey: 'B02_Inquiry_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'inqXkNo',
      quoteName: '报价'
    }
  };

  //必填字段
  const ArrRequired = [
    { flag: 'brandNameMustFlag', field: 'brandName', key: '品牌' },
    { flag: 'minPackageMustFlag', field: 'minPackage', key: '最小包装' },
    { flag: 'minPurchaseQtyFlag', field: 'minPurchaseQty', key: '最小采购量' },
    {
      flag: 'promisesDeliveryDateFlag',
      field: 'promiseDeliDays',
      key: '承诺交期'
    },
    {
      flag: 'manufacturersPartNoFlag',
      field: 'manufacturerProdCode',
      key: '制造商料号'
    },
    { flag: 'modelFeeFlag', field: 'modelFee', key: '模具费用' }
  ];

  const { state, dispatch } = useContext(ActionContext);
  const config = Config[props.type];
  config.dispatch = dispatch;

  const {
    companyCode,
    inited,
    error,
    setError,
    setErrorMsg,
    redirect,
    moreSign1,
    handleMore,
    decimalPlace,
    fileList,
    setShowLoading,
    setFileList,
    setRedirect,
    fieldSetting,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    setWorkflow,
    self
  } = useDetail(props, config);
  self.countTimer = 0;
  self.countDownTimer = 0;

  // const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });
  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [quoteDetail, setQuoteDetail] = useState({});
  const [prodList, setProdList] = useState([]);
  const [quoteEdit, setQuoteEdit] = useState(false);
  const [code, setCode] = useState('');
  const [currencyList, setCurrencyList] = useState([]);
  const [payWayList, setPayWayList] = useState([]);
  const [taxTypeList, setTaxTypeList] = useState([]);
  const [quoteBottom, setQuoteBottom] = useState(false);
  const [returnBottom, setReturnBottom] = useState(false);
  const [quoteNum, setQuoteNum] = useState(0);
  const [primaryQuoteData, setPrimaryQuoteData] = useState({});
  const [currQuoteItem, setCurrQuoteItem] = useState({});
  const [primaryData, setPrimaryData] = useState({});
  const [thresholdEndQty, setThresholdEndQty] = useState('');
  const [quotePrice, setQuotePrice] = useState('');
  const [promiseDeliDays, setPromiseDeliDays] = useState('');
  const [description, setDescription] = useState('');
  const [minPurchaseQty, setMinPurchaseQty] = useState('');
  const [manufacturerProdCode, setManufacturerProdCode] = useState('');
  const [brandName, setBrandName] = useState('');
  const [minPackage, setMinPackage] = useState('');
  const [modelFee, setModelFee] = useState('');
  const [custCompanyParams, setCustCompanyParams] = useState({});
  const [sendBackTxt, setSendBackTxt] = useState('');
  const [isBackTxtError, setIsBackTxtError] = useState(false);
  const [backHelperText, setBackHelperText] = useState('');
  const [extendList, setExtendList] = useState([]);
  // const [fieldSetting, setFieldSetting] = useState([]);
  const [platformExtendN01, setExtendN01] = useState('');
  const [platformExtendN02, setExtendN02] = useState('');
  const [taxCode, setTaxCode] = useState('');
  const [taxName, setTaxName] = useState('');
  const [areaList, setAreaList] = useState([]);
  // const [bodyCustData, setBodyCustData] = useState({}); //单身自定义字段数据
  const [fieldSetting1, setFieldSetting1] = useState({
    headCustList: [],
    bodyCustList: []
  }); //自定义字段设置
  const [upSetFlag, setUpSetFlag] = useState(false);

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    if (fieldSetting.bodyCustList.length > 0) {
      fieldSetting.bodyCustList = fieldSetting.bodyCustList?.filter(i =>
        i.fieldCode.includes('platform')
      );
      setFieldSetting1(fieldSetting);
      if (!upSetFlag) {
        self.getDetail();
        setUpSetFlag(true);
      }
    }
  }, [fieldSetting, self, upSetFlag]);

  //根据依赖多次执行
  useEffect(() => {
    let { match } = props;
    setCode(match.params.code);
    let code1 = match.params.code;
    let isNew = code1 ? false : true;
    if (isNew) {
      setQuoteEdit(true);
    }
  }, [props]);

  //处理详情数据
  self.afterGetDetail = async function (data) {
    let list = data.prodList || [];
    let companyParams = {};
    if (data.billType === 2) {
      config.quoteName = '投标';
    }
    EnumService.getValue('B02_Inquiry_Bill_Type', data.billType).then(value => {
      data.billTypeName = value;
      forceUpdate();
    });
    EnumService.getList('B01_Mobile_Area').then(value => {
      let arr = value.map(item => {
        return {
          id: item.subKey,
          text: item.subValue
        };
      });
      setAreaList(arr);
    });
    data.taxRateShow = data.taxRate * 100;
    data.priceContainTaxName =
      data.priceContainTaxFlag === 0
        ? '不限'
        : data.priceContainTaxFlag === 1
        ? '含税价'
        : '未税价';
    if (!self.isPurchase) {
      list.forEach(async item => {
        //报价prodList，新建时的默认值
        item.quoProducts = {
          inqLineNo: item.lineNo,
          abandonFlag: 0,
          quotes: [
            {
              thresholdEndQty: Util.isEmpty(item.pricingQuantity)
                ? item.purchaseQty
                : item.pricingQuantity,
              quotePrice: ''
            }
          ],
          taxCode: data.taxCode,
          taxName: data.taxName
        };

        await fieldSetting.bodyCustList?.forEach(field => {
          item.quoProducts[field.fieldCode] = item[field.fieldCode];
        });
        // descTag （Integer） 来源单据描述标识：0:手填或已选物料；1：导入自定义标题属性 默认0；
        // sourceOrderType 来源单据类型 0:商机；1：内部询价单
        if (item.descTag === 1 && !Util.isEmpty(item.description)) {
          item.descriptionList = showItemsDes(item.description);
        }
        Util.genExtendFields(item);
      });

      let quoteDetail2 = quoteDetail;
      quoteDetail2.transportTypeCode = data.transportTypeCode;
      quoteDetail2.transportTypeName = data.transportTypeName;
      quoteDetail2.deliveryTypeCode = data.deliveryTypeCode;
      quoteDetail2.deliveryTypeName = data.deliveryTypeName;
      quoteDetail2.quoteCurrencyCode = data.quoteCurrencyCode;
      quoteDetail2.quoteCurrencyName = data.quoteCurrencyName;
      quoteDetail2.taxRateShow = data.taxRateShow;
      quoteDetail2.taxCode = data.taxCode;
      quoteDetail2.taxName = data.taxName;
      quoteDetail2.invoiceType = data.invoiceType;
      quoteDetail2.payWayCode = data.payWayCode;
      quoteDetail2.payWayName = data.payWayName;
      quoteDetail2.offerValidityDateStart = data.priceValidDateStart;
      quoteDetail2['offerValidityDateStartShow'] = formatDate(
        quoteDetail2.offerValidityDateStart,
        'YYYY-MM-DD'
      );
      quoteDetail2.offerValidityDate = data.priceValidDateEnd;
      quoteDetail2['offerValidityDateShow'] = formatDate(
        quoteDetail2.offerValidityDate,
        'YYYY-MM-DD'
      );
      quoteDetail2.deliveryPoint = data.deliveryPoint;
      quoteDetail2.deliveryPointCode = data.deliveryPointCode;

      setQuoteDetail(quoteDetail2);

      CompanyService.getCompanyParamsByCodes(
        data.customerCode,
        [
          'Inquiry_quantity_can_not_be_empty_config',
          'Inquiry_publish_result_config',
          'Allow_quote_unit_price_to_be_zero',
          'Inq_allow_part_offer'
        ],
        false
      ).then(rs => {
        if (Array.isArray(rs)) {
          rs.forEach(item => {
            companyParams[item.paramCode] = item.paramValue;
            setCustCompanyParams(companyParams);
          });
        }
      });
    } else {
      list.forEach(item => {
        EnumService.getValue('B02_Inquiry_Bill_Type', item.billType).then(
          value => {
            item.billTypeName = value;
            forceUpdate();
          }
        );
        // descTag （Integer） 来源单据描述标识：0:手填或已选物料；1：导入自定义标题属性 默认0；
        // sourceOrderType 来源单据类型 0:商机；1：内部询价单
        if (item.descTag === 1 && !Util.isEmpty(item.description)) {
          item.descriptionList = showItemsDes(item.description);
        }
        Util.genExtendFields(item);
      });
      data.quoteCurrencyName = data.quoteCurrencyName || '人民币'; //默认人民币

      CompanyService.getCompanyParamsByCodes(
        data.companyCode,
        [
          'Inquiry_quantity_can_not_be_empty_config',
          'Inquiry_publish_result_config'
        ],
        false
      ).then(rs => {
        if (Array.isArray(rs)) {
          rs.forEach(item => {
            companyParams[item.paramCode] = item.paramValue;
            setCustCompanyParams(companyParams);
          });
        }
      });
    }

    if (!code) {
      getSelectList(data);
    }
    // await getFieldSetting(self.isPurchase ? companyCode : data.customerCode);
    await getContact();
    setProdList(list);
    setDetail(data);
    if (code) {
      getQuoteDetail(code, data);
    } else if (!self.isPurchase) {
      getQuoteList(data);
    }
  };

  //获取员工档案的联系方式
  async function getContact() {
    let companyList = User.getCompanyList() || [];
    if (companyList.length === 0) {
      return;
    }
    let xkUniqueCode = companyList.filter(
      item => item.companyCode === companyCode
    )[0].employeeXkUniqueCode;
    let postbody = {
      companyCode: companyCode,
      xkUniqueCode: xkUniqueCode,
      apiPath: '/archives/compEmployee/getDetailById'
    };
    let arrPromise = [Http.post('/api/cloudCenter', postbody)];

    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      if (response.success) {
        let data = response.data;
        let data1 = quoteDetail;
        data1.contactsName = data.employeeName;
        data1.mobile = data.mobile;
        data1.mobileArea = data.mobileArea;
        data1.mailbox = data.email;
        setQuoteDetail(data1);
      }
    });
  }

  //获取报价单详情
  function getQuoteDetail(quoXkNo, detailData) {
    let postbody = {
      inqXkNo: self.id,
      quoXkNo: quoXkNo,
      companyCode: companyCode,
      apiPath: config.apiPathQuoteDetail
    };

    let arrPromise = [
      Http.post('/api/cloudCenter', postbody),
      EnumService.getList('B02_Quote_Status')
    ];

    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      if (response.success) {
        let data = response.data;
        let list = detailData;
        list.prodList?.forEach(item => {
          item.quoProducts =
            data.quoProducts.filter(row => item.lineNo === row.inqLineNo)[0] ||
            item.quoProducts;
        });
        if (!code) {
          delete data.status;
          delete data.quoInnerNo;
        }
        EnumService.getValue('B02_Quote_Status', data.status).then(value => {
          data.statusName = value;
          forceUpdate();
        });
        data.taxRateShow = data.taxRate * 100;
        data.priceContainTaxName =
          data.priceContainTaxFlag === 0
            ? '不限'
            : data.priceContainTaxFlag === 1
            ? '含税价'
            : '未税价';
        setPrimaryData(Util.mergeAll([list]));
        setQuoteDetail(data);
      } else {
        if (prodList[0].quoProducts.length > 0) {
          let data = quoteDetail;
          data.status = prodList[0].quoProducts[0].status;
          setQuoteDetail(data);
        }
      }
    });
  }

  // 获取报价列表
  function getQuoteList(detailData) {
    let postbody = {
      inqXkNo: self.id,
      companyCode: companyCode,
      apiPath: '/inquiry/quoteOrder/list'
    };

    let arrPromise = [Http.post('/api/cloudCenter', postbody)];

    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      if (response.success) {
        let list = response.data.list || [];
        let quoXkNo;
        if (list.length > 0) {
          quoXkNo = list[0].quoXkNo;
          getQuoteDetail(quoXkNo, detailData);
        }
      }
    });
  }

  //获取自定义字段设置
  // async function getFieldSetting(customerCode) {
  //   await CustFieldService.getSetting(
  //     companyCode,
  //     customerCode,
  //     true,
  //     51,
  //     dispatch
  //   ).then(async setting => {
  //     if (setting) {
  //       //上游单据字段转换
  //       await CustFieldService.transformSourceField(
  //         companyCode,
  //         customerCode,
  //         setting
  //       );

  //       //单头单身日期字段，转换为时间戳
  //       CustFieldService.parseCustFields(setting, {}, prodList, true);
  //       setting.bodyCustList = setting.bodyCustList?.filter(item =>
  //         item.fieldCode.includes('platform')
  //       );

  //       setFieldSetting(setting);
  //     }
  //   });
  // }

  // 导入清单的物料,(相关说明显示)
  function showItemsDes(des) {
    let obj = JSON.parse(des);
    // 物料群组为空
    let title = !Util.isEmpty(obj.customTitle)
      ? obj.customTitle.split(',')
      : [];
    let value = !Util.isEmpty(obj.customValue)
      ? obj.customValue.split(',')
      : [];
    let arr = [];
    if (!Util.isEmpty(title)) {
      title.forEach((item, index) => {
        if (!Util.isEmpty(item)) {
          arr.push({ text: value[index] || '', title: item });
        }
      });
    }
    return arr;
  }

  //输入框值变化时清空当前error
  function handleInput(e, key) {
    quoteDetail[key] = e.target.value;
    setQuoteDetail(quoteDetail);
    forceUpdate();
  }
  //输入框值变化时(日期)
  function handleInputDate(e, key) {
    let date = e.target.value;
    quoteDetail[key] = new Date(date).getTime();
    setQuoteDetail(quoteDetail);
    forceUpdate();
  }

  function handle(type) {
    switch (type) {
      case 'quoteSave':
        quoteSave();
        break;
      case 'cancelSave':
        cancelSave();
        break;
      case 'editClick':
        editClick();
        break;
      case 'handleConfirm':
        quotePublish(code);
        break;
      default:
    }
  }

  //保存报价
  function quoteSave() {
    let error1 = false;
    let error2 = false;
    let error3 = false;
    let productNameError = '';
    let extendNameError = '';
    let quoProducts = [];
    detail.prodList?.forEach(item => {
      item.quoProducts.quotes?.forEach((row, i) => {
        row.subLineNo = i + 1;
        row.thresholdStartQty = item.quoProducts.quotes[i - 1]
          ? Number(item.quoProducts.quotes[i - 1].thresholdEndQty)
          : 0;
        if (
          !item.quoProducts.abandonFlag &&
          item.status !== 3 &&
          (!row.thresholdEndQty ||
            (custCompanyParams['Allow_quote_unit_price_to_be_zero'] !== '1' &&
              !row.quotePrice)) &&
          custCompanyParams['Inq_allow_part_offer'] === '0' &&
          custCompanyParams['Inquiry_quantity_can_not_be_empty_config'] === '1'
          // (!row.thresholdEndQty || !row.quotePrice)
        ) {
          error2 = true;
        }
        if (
          item.upperLimitPrice &&
          row.quotePrice > item.upperLimitPrice &&
          !item.quoProducts.abandonFlag
        ) {
          productNameError = item.productName;
          error1 = true;
        }
      });
      item.quoProducts.abandonFlag = item.quoProducts.abandonFlag ? 1 : 0;
      if (item.quoProducts.taxCode) {
        item.quoProducts.taxRate = taxTypeList.filter(
          tax => tax.id === item.quoProducts.taxCode
        )[0].taxRate;
      }
      quoProducts.push(item.quoProducts);

      //非弃报单身自定义字段不能为空
      extendList.forEach(row => {
        if (
          item.quoProducts.abandonFlag === 0 &&
          row.needVendorInputFlag === 1 &&
          row.openedFlag === 1 &&
          row.isRequiredField === 1 &&
          row.fieldLevel === 1
        ) {
          if (Util.isEmpty(item.quoProducts[row.fieldCode]) && !error3) {
            extendNameError = row.transName;
            error3 = true;
          }
        }
      });
    });

    let reg = /^[+]{0,1}(\d+)$/;
    if (
      quoProducts.some(
        row =>
          typeof row.promiseDeliDays === 'string' &&
          !reg.test(row.promiseDeliDays)
      )
    ) {
      ModalService.showError('承诺交期需为整数', dispatch);
      return;
    }

    if (error1) {
      ModalService.showError(
        '【' + productNameError + '】的报价单价不能超过上限价格',
        dispatch
      );
      return;
    }

    if (error2) {
      ModalService.showError(
        '未勾选“弃报”的物料，报价数量和报价金额不能为空！',
        dispatch
      );
      return;
    }

    if (error3) {
      ModalService.showError(extendNameError + '不能为空', dispatch);
      return;
    }

    let postbody = {
      action: 'save',
      companyCode: companyCode,
      quoXkNo: code,
      quoInnerNo: quoteDetail.quoInnerNo,
      inqXkNo: self.id,
      customerXkUniqueCode: detail.customerXkUniqueCode,
      description: quoteDetail.description,
      fileMd5s: quoteDetail.fileMd5s,
      quoteCurrencyCode: quoteDetail.quoteCurrencyCode,
      quoteCurrencyName: quoteDetail.quoteCurrencyName,
      taxCode: quoteDetail.taxCode,
      taxName: quoteDetail.taxName,
      taxRate: quoteDetail.taxRateShow / 100,
      payWayCode: quoteDetail.payWayCode,
      payWayName: quoteDetail.payWayName,
      exchangeRate: quoteDetail.exchangeRate,
      offerValidityDate: quoteDetail.offerValidityDate,
      offerValidityDateStart: quoteDetail.offerValidityDateStart,
      paymentCycleName: quoteDetail.paymentCycleName,
      priceContainTaxFlag: quoteDetail.priceContainTaxFlag,
      mobile: quoteDetail.mobile,
      mobileArea: quoteDetail.mobileArea,
      mailbox: quoteDetail.mailbox,
      contactsName: quoteDetail.contactsName,
      quoProducts: quoProducts,
      apiPath: '/inquiry/quoteOrder/save'
    };

    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        ModalService.showTip('报价保存成功', dispatch);
        quoteDetail.quoXkNo = response.data;
        setQuoteEdit(false);
        setQuoteDetail(quoteDetail);
        if (!code) {
          setRedirect(
            '/mp/sale/inquiry/prod/quote/detail/' +
              companyCode +
              '/' +
              self.id +
              '/' +
              response.data
          );
        }
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  // 取消保存
  function cancelSave() {
    if (!code) {
      setRedirect(
        '/mp/sale/inquiry/prod/detail/' + companyCode + '/' + self.id
      );
    } else {
      setQuoteEdit(false);
      setDetail(primaryData);
    }
  }

  // 编辑
  function editClick() {
    quoteDetail['offerValidityDateShow'] = formatDate(
      quoteDetail.offerValidityDate,
      'YYYY-MM-DD'
    );
    quoteDetail['offerValidityDateStartShow'] = formatDate(
      quoteDetail.offerValidityDateStart,
      'YYYY-MM-DD'
    );
    quoteDetail['exchangeRate'] = quoteDetail.exchangeRate
      ? quoteDetail.exchangeRate.toString()
      : '';
    setQuoteDetail(quoteDetail);
    setQuoteEdit(true);
    getSelectList(detail);
  }

  //发布报价
  function quotePublish(quoXkNo) {
    let arr = [];
    arr.findIndex(index => index === 1);
    let postbody = {
      companyCode: companyCode,
      quoXkNo: quoXkNo,
      apiPath: config.quotePublishApiPath
    };
    InquiryService.publishQuoteInquiry(
      postbody,
      data => {
        if (data?.checkResult === 'Dynamic_Inquiry_ERR_181') {
          InquiryService.publishQuoteInquiry(
            postbody,
            data2 => {
              self.getDetail();
            },
            dispatch,
            data
          );
          return;
        }
        self.getDetail();
      },
      dispatch
    );
  }

  // 获取参数列表（币别，付款条件，税别）
  function getSelectList(detailData) {
    let postbodyPayway = {
      apiPath: '/archives/compPayway/getListByCompCode',
      companyCode: detailData.customerCode
    };
    let postbodyTaxType = {
      apiPath: '/archives/compTaxType/getListByCompCode',
      companyCode: detailData.customerCode
    };

    let arrPromise = [
      CompanyService.getCurrencyList(detailData.customerCode),
      Http.post('/api/cloudCenter', postbodyPayway),
      Http.post('/api/cloudCenter', postbodyTaxType)
    ];

    Promise.all(arrPromise).then(arrResponse => {
      let currencyList1 = arrResponse[0]; // 币别;
      let responsePay = arrResponse[1]; // 付款条件
      let responseTax = arrResponse[2]; // 税别
      let payWayList1 = [];
      let taxTypeList1 = [];

      if (responsePay.success) {
        payWayList1 = responsePay.data
          .filter(item => item.payWayType === 2)
          .map(item => {
            let text = '(' + item.payWayCode + ') ' + item.payWayName;
            return {
              id: item.payWayCode,
              text: text,
              payWayName: item.payWayName
            };
          });
      }
      if (responseTax.success) {
        taxTypeList1 = responseTax.data.map(item => {
          let text = '(' + item.taxCode + ') ' + item.taxName;
          return {
            id: item.taxCode,
            name: item.taxName,
            text: text,
            taxRate: item.taxRate,
            isContainTax: item.isContainTax,
            taxName: item.taxName
          };
        });
      }

      setCurrencyList(currencyList1);
      setPayWayList(payWayList1);
      setTaxTypeList(taxTypeList1);
    });
  }

  // 修改报价信息
  function handleQuoteChange(name, event) {
    if (self.isPurchase) {
      if (Util.isEmpty(event.target.value)) {
        setIsBackTxtError(true);
        setSendBackTxt(event.target.value);
        setBackHelperText('退回原因不能为空！');
      } else {
        setIsBackTxtError(false);
        setSendBackTxt(event.target.value);
        setBackHelperText('');
      }
    } else {
      let val = Util.qtyChange(event.target.value);
      if (['promiseDeliDays', 'minPurchaseQty'].includes(name)) {
        currQuoteItem[name] = val;
      } else if (['thresholdEndQty', 'quotePrice'].includes(name)) {
        currQuoteItem.quotes[0][name] = val;
      } else {
        currQuoteItem[name] = event.target.value;
      }
      if (name === 'taxCode') {
        taxTypeList.forEach(item => {
          if (item.id === currQuoteItem[name]) {
            currQuoteItem['taxName'] = item.taxName;
            currQuoteItem['taxRate'] = item.taxRate;
          }
        });
        if (currQuoteItem.taxCode !== quoteDetail.taxCode) {
          quoteDetail.taxCode = '';
          quoteDetail.taxName = '';
          quoteDetail.taxRateShow = '';
        }
      }
      let _currQuoteItem = currQuoteItem;
      let thresholdEndQty1 = _currQuoteItem.quotes[0].thresholdEndQty,
        quotePrice1 = _currQuoteItem.quotes[0].quotePrice,
        promiseDeliDays1 = _currQuoteItem.promiseDeliDays,
        description1 = _currQuoteItem.description,
        minPurchaseQty1 = _currQuoteItem.minPurchaseQty,
        manufacturerProdCode1 = _currQuoteItem.manufacturerProdCode,
        brandName1 = _currQuoteItem.brandName,
        minPackage1 = _currQuoteItem.minPackage,
        modelFee1 = _currQuoteItem.modelFee,
        _platformExtendN01 = _currQuoteItem.platformExtendN01,
        _platformExtendN02 = _currQuoteItem.platformExtendN02,
        _taxCode = _currQuoteItem.taxCode,
        _taxName = _currQuoteItem.taxName;
      setThresholdEndQty(thresholdEndQty1);
      setQuotePrice(quotePrice1);
      setPromiseDeliDays(promiseDeliDays1);
      setDescription(description1);
      setMinPurchaseQty(minPurchaseQty1);
      setManufacturerProdCode(manufacturerProdCode1);
      setBrandName(brandName1);
      setMinPackage(minPackage1);
      setModelFee(modelFee1);
      setExtendN01(_platformExtendN01);
      setExtendN02(_platformExtendN02);
      setTaxCode(_taxCode);
      setTaxName(_taxName);
      forceUpdate();
    }
  }

  // 修改报价信息(币别)
  function handleCurrencyChange(event) {
    let val = event.target.value;
    quoteDetail['quoteCurrencyCode'] = val;
    currencyList.forEach(item => {
      if (item.id === val) {
        quoteDetail['quoteCurrencyName'] = item.currencyName;
      }
    });
    setQuoteDetail(quoteDetail);
    forceUpdate();
  }
  // 修改报价信息(付款条件)
  function handlePayWayChange(event) {
    let val = event.target.value;
    quoteDetail['payWayCode'] = val;
    payWayList.forEach(item => {
      if (item.id === val) {
        quoteDetail['payWayName'] = item.payWayName;
      }
    });
    setQuoteDetail(quoteDetail);
    forceUpdate();
  }

  // 修改报价信息(联系方式的区号)
  function handleAreaChange(event) {
    let val = event.target.value;
    quoteDetail['mobileArea'] = val;
    setQuoteDetail(quoteDetail);
    forceUpdate();
  }

  // 修改报价信息(税别)
  function handleTaxTypeChange(event) {
    let val = event.target.value;
    quoteDetail['taxCode'] = val;
    taxTypeList.forEach(item => {
      if (item.id === val) {
        quoteDetail['taxName'] = item.taxName;
        quoteDetail['isTaxRate'] = item.taxRate;
        quoteDetail['taxRateShow'] = item.taxRate * 100;
        quoteDetail['priceContainTaxFlag'] = item.isContainTax === 1 ? 1 : 2;
        quoteDetail['priceContainTaxName'] =
          quoteDetail.priceContainTaxFlag === 0
            ? '不限'
            : quoteDetail.priceContainTaxFlag === 1
            ? '含税价'
            : '未税价';
        prodList.forEach(prod => {
          prod.quoProducts.taxCode = quoteDetail.taxCode;
          prod.quoProducts.taxName = quoteDetail.taxName;
          prod.quoProducts.taxRateShow = quoteDetail.taxRateShow;
        });
      }
    });
    setQuoteDetail(quoteDetail);
    forceUpdate();
  }

  // 弃报按钮
  function handleCheckbox(index, event) {
    detail.prodList[index].quoProducts.abandonFlag = event.target.checked
      ? 1
      : 0;
    setDetail(detail);
    forceUpdate();
  }

  // 取消报价按钮
  function cancelQuoteClick() {
    detail.prodList[quoteNum] = primaryQuoteData;
    setQuoteBottom(false);
    setDetail(detail);
  }

  // 确定报价按钮
  function sureQuoteClick() {
    let list = Util.mergeAll([primaryQuoteData]);
    list.quoProducts = {
      ...currQuoteItem
    };
    list.quoProducts.quotes[0].thresholdEndQty = thresholdEndQty;
    list.quoProducts.quotes[0].quotePrice = quotePrice;
    list.quoProducts.quotes = [list.quoProducts.quotes[0]]; // 覆盖原有数据
    list.quoProducts.promiseDeliDays = promiseDeliDays;
    list.quoProducts.description = description;
    list.quoProducts.minPurchaseQty = minPurchaseQty;
    list.quoProducts.manufacturerProdCode = manufacturerProdCode;
    list.quoProducts.brandName = brandName;
    list.quoProducts.minPackage = minPackage;
    list.quoProducts.modelFee = modelFee;
    // list.quoProducts.platformExtendN01 = platformExtendN01;
    // list.quoProducts.platformExtendN02 = platformExtendN02;
    list.quoProducts.taxCode = taxCode;
    list.quoProducts.taxName = taxName;

    detail.prodList[quoteNum] = list;
    if (!check(detail.prodList[quoteNum])) {
      return;
    }
    setQuoteBottom(false);
    setDetail(detail);
  }

  // 校验
  function check(item) {
    // 非弃报的物料必填字段校验
    let abandonFlag = item.quoProducts && item.quoProducts.abandonFlag ? 1 : 0;
    if (abandonFlag !== 1) {
      for (let o of ArrRequired) {
        let { flag, field, key } = o;
        if (detail[flag] === 1 && Util.isEmpty(item.quoProducts[field])) {
          ModalService.showError('必填字段不能为空', dispatch);
          return false;
        }
      }

      let bodyData = CustFieldService.getBodyData(
        fieldSetting,
        item.quoProducts,
        self.isPurchase
      );

      CustFieldService.parseCustFields(
        fieldSetting,
        undefined,
        [bodyData],
        self.isPurchase
      );

      if (
        !CustFieldService.validate(
          undefined,
          [bodyData],
          fieldSetting,
          false,
          dispatch
        )
      ) {
        return false;
      }
    }
    return true;
  }

  function toggleDrawer(item, index) {
    if (!self.isPurchase) {
      setQuoteNum(index);
      let _primaryQuoteData = Util.mergeAll([item]);
      let _currQuoteItem = Util.mergeAll([item.quoProducts]);
      setPrimaryQuoteData(_primaryQuoteData);

      setCurrQuoteItem(_currQuoteItem);
      let thresholdEndQty1 = _currQuoteItem.quotes[0].thresholdEndQty,
        quotePrice1 = _currQuoteItem.quotes[0].quotePrice,
        promiseDeliDays1 = _currQuoteItem.promiseDeliDays,
        description1 = _currQuoteItem.description,
        minPurchaseQty1 = _currQuoteItem.minPurchaseQty,
        manufacturerProdCode1 = _currQuoteItem.manufacturerProdCode,
        brandName1 = _currQuoteItem.brandName,
        minPackage1 = _currQuoteItem.minPackage,
        modelFee1 = _currQuoteItem.modelFee,
        _platformExtendN01 = _currQuoteItem?.platformExtendN01,
        _platformExtendN02 = _currQuoteItem?.platformExtendN02,
        _taxCode = _currQuoteItem.taxCode,
        _taxName = _currQuoteItem.taxName;

      setThresholdEndQty(thresholdEndQty1);
      setQuotePrice(quotePrice1);
      setPromiseDeliDays(promiseDeliDays1);
      setDescription(description1);
      setMinPurchaseQty(minPurchaseQty1);
      setManufacturerProdCode(manufacturerProdCode1);
      setBrandName(brandName1);
      setMinPackage(minPackage1);
      setModelFee(modelFee1);
      setExtendN01(_platformExtendN01);
      setExtendN02(_platformExtendN02);
      setTaxCode(_taxCode);
      setTaxName(_taxName);

      forceUpdate();
    }
  }

  // 退回报价
  function handleRetrunQuote() {
    if (Util.isEmpty(sendBackTxt)) {
      setBackHelperText('退回原因不能为空！');
      setIsBackTxtError(true);
      return;
    }
    let postbody = {
      inqXkNo: self.id,
      quoXkNo: code,
      companyCode: companyCode,
      rejectReason: sendBackTxt,
      apiPath: '/inquiry/vendorQuoteOrder/reQuote'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        self.getDetail();
        ModalService.showTip('退回' + config.quoteName + '成功', dispatch);
      }
      setReturnBottom(false);
    });
  }

  //查看附件
  function showFileList(businessType, obj) {
    const { actions } = props;
    let businessKey = [57, 119].includes(businessType)
        ? obj.uniqueKey
        : obj.inqXkNo,
      xkNo = obj.inqXkNo,
      lineNo = businessType === 57 ? obj.inqLineNo : obj.lineNo || '0',
      cCode = [12, 57, 122].includes(businessType)
        ? quoteDetail[config.vendorCodeKey]
        : detail[config.companyCodeKey];
    setShowLoading(true);
    CompanyService.getFileList(
      businessType,
      businessKey,
      xkNo,
      lineNo,
      cCode
    ).then(res => {
      setShowLoading(false);
      if (Array.isArray(res)) {
        let arr = res.map(item => {
          return { ...item };
        });
        setFileList(arr);
      }
    });
    actions.openDownloadModal();
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {!self.isPurchase && detail.isSpecifyStepQuoteQty === 1 && (
        <p style={{ textAlign: 'center', color: 'red' }}>
          采购方要求按阶梯报价，请登录电脑操作
        </p>
      )}
      <div className="pb50">
        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>基础信息</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">标题</label>
              <div className="order-detail-value">{detail.billTitle}</div>
            </li>
            <li>
              <label className="order-detail-label">
                {self.isPurchase
                  ? '供应商名称'
                  : detail.billTypeName + '企业名称'}
              </label>
              <div className="order-detail-value">
                {self.isPurchase
                  ? quoteDetail.innerVendorName
                  : detail.innerCustomerName}
              </div>
            </li>
            {self.isPurchase && (
              <li>
                <label className="order-detail-label">供应商编码</label>
                <div className="order-detail-value">
                  {quoteDetail.innerVendorCode}
                </div>
              </li>
            )}

            <li>
              <label className="order-detail-label">
                {config.quoteName}状态
              </label>
              <div
                className={
                  [1].indexOf(quoteDetail.status) > -1
                    ? 'order-detail-value blue'
                    : [2, 3].indexOf(quoteDetail.status) > -1
                    ? 'order-detail-value red'
                    : [4, 5].indexOf(quoteDetail.status) > -1
                    ? 'order-detail-value green'
                    : 'order-detail-value'
                }
              >
                {quoteDetail.statusName}
              </div>
            </li>

            {!self.isPurchase && quoteDetail.status === 2 && (
              <li>
                <label className="order-detail-label">退回原因</label>
                <div className="order-detail-value yellow">
                  {quoteDetail.rejectReason}
                </div>
              </li>
            )}
          </ul>
        </div>

        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>{detail.billTypeName}信息</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">
                {detail.billTypeName}编号
              </label>
              <div className="order-detail-value">{self.id}</div>
            </li>
            <li>
              <label className="order-detail-label">发布时间</label>
              <div className="order-detail-value">
                {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}
              </div>
            </li>
            <li>
              <label className="order-detail-label">发布人</label>
              <div className="order-detail-value">{detail.publishName}</div>
            </li>
          </ul>
        </div>

        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>{config.quoteName}信息</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">
                {config.quoteName}编号
              </label>
              <div className="order-detail-value">{code}</div>
            </li>
            <li>
              <label className="order-detail-label">发布时间</label>
              <div className="order-detail-value">
                {formatDate(quoteDetail.quoteTime, 'YYYY-MM-DD HH:mm:ss')}
              </div>
            </li>
            <li>
              <label className="order-detail-label">发布人</label>
              <div className="order-detail-value">{quoteDetail.quoteName}</div>
            </li>
          </ul>
        </div>

        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>询价/招标类型</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">类型</label>
              <div className="order-detail-value blue">
                {detail.billTypeName}
              </div>
            </li>
            {detail.billType === 2 && (
              <li>
                <label className="order-detail-label">招标开始时间</label>
                <div className="order-detail-value">
                  {formatDate(detail.startDate, 'YYYY-MM-DD HH:mm:ss')}
                </div>
              </li>
            )}
            <li>
              <label className="order-detail-label">
                {detail.billType === 1 ? '询价截止时间' : '招标结束时间'}
              </label>
              <div className="order-detail-value">
                {formatDate(detail.endDate, 'YYYY-MM-DD HH:mm:ss')}
              </div>
            </li>
            {detail.showedVendorFlag === 1 && (
              <li>
                <label className="order-detail-label">物料使用客户</label>
                <div className="order-detail-value">
                  {detail.usedByCustomerInnerCode
                    ? '(' + detail.usedByCustomerInnerCode + ')'
                    : ''}
                  {detail.usedByCustomerInnerName}
                </div>
              </li>
            )}
          </ul>
        </div>

        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>{detail.billTypeName}物料</label>
          </div>
          <div className="order-detail-list">
            {!Util.isEmpty(prodList) &&
              prodList.map((item, index) => (
                <ExpansionPanel
                  key={String(item.id) + index}
                  defaultExpanded={true}
                  expanded={true}
                >
                  <ExpansionPanelSummary
                    // expandIcon={<ExpandMoreIcon />}
                    expanded
                    style={{
                      content: styles.expansionSum,
                      expanded: styles.expanded
                    }}
                  >
                    <div className="expansionList">
                      <h4>{item.productCode}</h4>
                      <p className="mb10">{item.productName}</p>
                      <ul className="clearfix">
                        <li className="single">
                          <span>物料规格：</span>
                          <p>{item.productScale}</p>
                        </li>
                        <li>
                          采购数量：
                          {formatNumber(
                            item.purchaseQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}{' '}
                          {item.purchaseUnitName}
                        </li>
                        <li>采购单位：{item.unitName}</li>
                        <li>
                          上限价格：
                          {item.upperLimitPrice
                            ? formatNumber(
                                item.upperLimitPrice,
                                decimalPlace.Price_Decimal_Place
                              ) + '元'
                            : ''}
                        </li>
                        <li className="single">
                          <span>相关说明：</span>
                          {item.descTag !== 1 && (
                            <p className="single">{item.description}</p>
                          )}
                          {item.descTag === 1 && (
                            <div>
                              {!Util.isEmpty(item.descriptionList) &&
                                item.descriptionList.map((val, i) => (
                                  <p key={i} className="ml15">
                                    {val.title}: {val.text}
                                  </p>
                                ))}
                            </div>
                          )}
                        </li>
                        {Array.isArray(item.fileMd5s) &&
                          item.fileMd5s.length > 0 && (
                            <li>
                              图纸/文档：
                              <span
                                className="attachment"
                                onClick={() => showFileList(119, item)}
                              >
                                {item.fileMd5s.length}个附件
                                <i className="icon-attachment"></i>
                              </span>
                            </li>
                          )}
                        {item.printExtendFields !== '' && (
                          <li className="single">
                            采购说明：{item.printExtendFields}
                          </li>
                        )}
                      </ul>
                    </div>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    {((self.isPurchase &&
                      item.quoProducts?.abandonFlag === 1) ||
                      (!self.isPurchase &&
                        item.quoProducts?.abandonFlag === 1)) && (
                      <div className="quoProductsList">
                        <span className="red">弃报</span>
                      </div>
                    )}
                    {((self.isPurchase &&
                      !Util.isEmpty(item.quoProducts?.quotes)) ||
                      (!self.isPurchase &&
                        item.quoProducts?.abandonFlag === 0)) && (
                      <div className="quoProductsList wid100">
                        <ul className="clearfix">
                          <li>
                            承诺交期：
                            {item.quoProducts.promiseDeliDays
                              ? item.quoProducts.promiseDeliDays + '天'
                              : ''}
                          </li>
                          <li>
                            最小采购量：
                            {formatNumber(
                              item.quoProducts.minPurchaseQty,
                              decimalPlace.Quantity_Decimal_Place
                            )}
                          </li>
                          <li>
                            制造商料号：
                            {item.quoProducts.manufacturerProdCode || ''}
                          </li>
                          <li>品牌：{item.quoProducts.brandName || ''}</li>
                          <li>最小包装：{item.quoProducts.minPackage || ''}</li>
                          <li>模具费用：{item.quoProducts.modelFee || ''}</li>
                          {/* {!Util.isEmpty(extendList) &&
                            extendList.map((extend, i) => (
                              <li key={i}>
                                {extend.transName}：
                                {item.quoProducts[extend.fieldCode] || ''}
                              </li>
                            ))} */}
                          <li>
                            报价结果：
                            {item.quoProducts.status === 4 && (
                              <span className="green">已入选</span>
                            )}
                            {item.quoProducts.status === 3 && (
                              <span className="red">未入选</span>
                            )}
                          </li>

                          <li>
                            税别：{item.quoProducts.taxCode || ''}
                            {item.quoProducts.taxName || '--'}
                          </li>

                          {custCompanyParams[
                            'Inquiry_publish_result_config'
                          ]?.indexOf('2') > -1 && (
                            <li>
                              报价排名：{item.quoProducts.quoteRank || ''}
                            </li>
                          )}
                          {custCompanyParams[
                            'Inquiry_publish_result_config'
                          ]?.indexOf('3') > -1 && (
                            <li>
                              入选价格：{item.quoProducts.selectPrice || ''}
                            </li>
                          )}

                          {!self.isPurchase &&
                            custCompanyParams[
                              'Inquiry_publish_result_config'
                            ]?.indexOf('4') > -1 && (
                              <li>
                                采购配额(%)：
                                {item.quoProducts.purchaseRate || ''}
                              </li>
                            )}
                          {!self.isPurchase &&
                            custCompanyParams[
                              'Inquiry_publish_result_config'
                            ]?.indexOf('4') > -1 && (
                              <li>
                                配额数量：{item.quoProducts.quotaQty || ''}
                              </li>
                            )}

                          <li className="single">
                            相关说明：{item.quoProducts.description || ''}
                          </li>

                          {Array.isArray(item.quoProducts.fileMd5s) &&
                            item.quoProducts.fileMd5s.length > 0 && (
                              <li>
                                图纸/文档：
                                <span
                                  className="attachment"
                                  onClick={() =>
                                    showFileList(57, item.quoProducts)
                                  }
                                >
                                  {item.quoProducts.fileMd5s.length}个附件
                                  <i className="icon-attachment"></i>
                                </span>
                              </li>
                            )}
                        </ul>

                        {/* 单身自定义字段 */}
                        <BodydCustField
                          fieldSetting={fieldSetting1}
                          line={item.quoProducts}
                          isPurchase={self.isPurchase}
                        ></BodydCustField>
                        {!Util.isEmpty(item.quoProducts.quotes) &&
                          item.quoProducts.quotes.map((val, valIndex) => (
                            <ul key={valIndex} className="clearfix">
                              <li>
                                报价数量：
                                {formatNumber(
                                  val.thresholdEndQty,
                                  decimalPlace.Quantity_Decimal_Place
                                )}
                              </li>
                              <li>
                                报价单价：
                                {val.quotePrice
                                  ? formatNumber(
                                      val.quotePrice,
                                      decimalPlace.Price_Decimal_Place
                                    ) + '元'
                                  : ''}
                              </li>
                            </ul>
                          ))}
                      </div>
                    )}
                  </ExpansionPanelDetails>
                  {quoteEdit && (
                    <div>
                      <Divider />
                      <ExpansionPanelActions style={styles.expanActions}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                item.quoProducts?.abandonFlag === 1
                                  ? true
                                  : false
                              }
                              style={styles.checkbox}
                              onChange={event => handleCheckbox(index, event)}
                              value="checkedB"
                            />
                          }
                          label="弃报"
                        />
                        <Fab
                          variant="extended"
                          color="primary"
                          size="large"
                          style={styles.quoteBt}
                          onClick={() => {
                            setQuoteBottom(true);
                            forceUpdate();
                            toggleDrawer(item, index);
                          }}
                        >
                          {config.quoteName}
                        </Fab>
                      </ExpansionPanelActions>
                    </div>
                  )}
                </ExpansionPanel>
              ))}
          </div>
        </div>

        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>{detail.billTypeName}说明</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">报价币别</label>
              <div className="order-detail-value">
                {detail.quoteCurrencyName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">是否含税</label>
              <div className="order-detail-value">
                {detail.priceContainTaxName}
              </div>
            </li>
            {detail.priceContainTaxFlag && detail.taxRate ? (
              <li>
                <label className="order-detail-label">税率</label>
                <div className="order-detail-value">{detail.taxRateShow}%</div>
              </li>
            ) : (
              ''
            )}
            <li>
              <label className="order-detail-label">税别</label>
              <div className="order-detail-value">{detail.taxName}</div>
            </li>
            <li>
              <label className="order-detail-label">付款条件</label>
              <div className="order-detail-value">{detail.payWayName}</div>
            </li>
            <li>
              <label className="order-detail-label">付款周期</label>
              <div className="order-detail-value">
                {detail.paymentCycleName}
              </div>
            </li>
            <li>
              <label className="order-detail-label">说明</label>
              <div className="order-detail-value">{detail.description}</div>
            </li>
            {Array.isArray(detail.fileMd5s) && detail.fileMd5s.length > 0 && (
              <li>
                <label className="order-detail-label">
                  {detail.billTypeName}文件
                </label>
                <div className="order-detail-value">
                  <span
                    className="attachment"
                    onClick={() => showFileList(11, detail)}
                  >
                    {detail.fileMd5s.length}个附件
                    <i className="icon-attachment"></i>
                  </span>
                </div>
              </li>
            )}
          </ul>
        </div>

        <div className="order-detail-block">
          <div className="order-detail-title">
            <label>报价说明</label>
          </div>
          <ul>
            <li>
              <label className="order-detail-label">
                报价币别
                <i className="icon-required"></i>
              </label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div>
                    <Select
                      value={quoteDetail.quoteCurrencyCode || ''}
                      onChange={event => handleCurrencyChange(event)}
                      placeholder="请输入币别"
                      className="select-company-list"
                    >
                      {!Util.isEmpty(currencyList) &&
                        currencyList.map((item, index) => (
                          <MenuItem key={index} value={item.id}>
                            {item.text}
                          </MenuItem>
                        ))}
                    </Select>
                  </div>
                ) : (
                  <div>{quoteDetail.quoteCurrencyName}</div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">汇率</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div>
                    <Input
                      defaultValue={quoteDetail.exchangeRate}
                      placeholder="请输入汇率"
                      className="tr"
                      onChange={e => handleInput(e, 'exchangeRate')}
                    />
                  </div>
                ) : (
                  <div>{quoteDetail.exchangeRate}</div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">是否含税</label>
              <div className="order-detail-value">
                <div>{quoteDetail.priceContainTaxName}</div>
              </div>
            </li>
            {quoteDetail.priceContainTaxFlag === 1 && quoteDetail.taxRate ? (
              <li>
                <label className="order-detail-label">税率</label>
                <div className="order-detail-value">
                  {quoteDetail.taxRateShow}%
                </div>
              </li>
            ) : (
              ''
            )}
            <li>
              <label className="order-detail-label">税别</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div>
                    <Select
                      value={quoteDetail.taxCode || ''}
                      disabled={
                        (detail.isAccordingToVendor === 1 &&
                          !Util.isEmpty(detail.taxCode)) ||
                        detail.quoteLimitFlag !== 0
                      }
                      onChange={event => handleTaxTypeChange(event)}
                      className="select-company-list"
                    >
                      {!Util.isEmpty(taxTypeList) &&
                        taxTypeList.map((item, index) => (
                          <MenuItem key={index} value={item.id}>
                            {item.text}
                          </MenuItem>
                        ))}
                    </Select>
                  </div>
                ) : (
                  <div>{quoteDetail.taxName}</div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">付款条件</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div>
                    <Select
                      value={quoteDetail.payWayCode || ''}
                      onChange={event => handlePayWayChange(event)}
                      className="select-company-list"
                    >
                      {!Util.isEmpty(payWayList) &&
                        payWayList.map((item, index) => (
                          <MenuItem key={index} value={item.id}>
                            {item.text}
                          </MenuItem>
                        ))}
                    </Select>
                  </div>
                ) : (
                  <div>{quoteDetail.payWayName}</div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">付款周期</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div>
                    <Input
                      defaultValue={quoteDetail.paymentCycleName}
                      placeholder="请输入付款周期"
                      className="tr"
                      onChange={e => handleInput(e, 'paymentCycleName')}
                    />
                  </div>
                ) : (
                  <div>{quoteDetail.paymentCycleName}</div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">价格生效日期</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div className="f14 tr">
                    <Input
                      defaultValue={quoteDetail.offerValidityDateStartShow}
                      type="date"
                      className="tr"
                      onChange={e =>
                        handleInputDate(e, 'offerValidityDateStart')
                      }
                    />
                  </div>
                ) : (
                  <div>
                    {formatDate(
                      quoteDetail.offerValidityDateStart,
                      'YYYY-MM-DD'
                    )}
                  </div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">失效日期</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div className="f14 tr">
                    <Input
                      defaultValue={quoteDetail.offerValidityDateShow}
                      type="date"
                      className="tr"
                      onChange={e => handleInputDate(e, 'offerValidityDate')}
                    />
                  </div>
                ) : (
                  <div>
                    {formatDate(quoteDetail.offerValidityDate, 'YYYY-MM-DD')}
                  </div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">说明</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div>
                    <Input
                      placeholder="请输入说明"
                      defaultValue={quoteDetail.description}
                      className="tr"
                      onChange={e => handleInput(e, 'description')}
                    />
                  </div>
                ) : (
                  <div>{quoteDetail.description}</div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">联系人</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div>
                    <Input
                      placeholder="请输入联系人"
                      defaultValue={quoteDetail.contactsName}
                      className="tr"
                      onChange={e => handleInput(e, 'contactsName')}
                    />
                  </div>
                ) : (
                  <div>{quoteDetail.contactsName}</div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">联系方式</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div style={{ display: 'flex' }}>
                    <Select
                      value={quoteDetail.mobileArea || ''}
                      onChange={event => handleAreaChange(event)}
                      className="select-company-list"
                      style={{ width: '150px' }}
                    >
                      {!Util.isEmpty(areaList) &&
                        areaList.map((item, index) => (
                          <MenuItem key={index} value={item.id}>
                            {item.text}
                          </MenuItem>
                        ))}
                    </Select>
                    <Input
                      defaultValue={quoteDetail.mobile}
                      className="tr"
                      onChange={e => handleInput(e, 'mobile')}
                    />
                  </div>
                ) : (
                  <div>
                    {quoteDetail.mobileArea}&nbsp;&nbsp;
                    {quoteDetail.mobile}
                  </div>
                )}
              </div>
            </li>
            <li>
              <label className="order-detail-label">联系邮箱</label>
              <div className="order-detail-value">
                {quoteEdit ? (
                  <div>
                    <Input
                      placeholder="请输入联系邮箱"
                      defaultValue={quoteDetail.mailbox}
                      className="tr"
                      onChange={e => handleInput(e, 'mailbox')}
                    />
                  </div>
                ) : (
                  <div>{quoteDetail.mailbox}</div>
                )}
              </div>
            </li>
            {Array.isArray(quoteDetail.fileMd5s) &&
              quoteDetail.fileMd5s.length > 0 && (
                <li>
                  <label className="order-detail-label">附件</label>
                  <div className="order-detail-value">
                    <span
                      className="attachment"
                      onClick={() => showFileList(12, quoteDetail)}
                    >
                      {quoteDetail.fileMd5s.length}个附件
                      <i className="icon-attachment"></i>
                    </span>
                  </div>
                </li>
              )}
            {Array.isArray(quoteDetail.commitFileMd5s) &&
              quoteDetail.commitFileMd5s.length > 0 && (
                <li>
                  <label className="order-detail-label">报价承诺函</label>
                  <div className="order-detail-value">
                    <span
                      className="attachment"
                      onClick={() => showFileList(122, quoteDetail)}
                    >
                      {quoteDetail.commitFileMd5s.length}个附件
                      <i className="icon-attachment"></i>
                    </span>
                  </div>
                </li>
              )}
          </ul>
        </div>
      </div>
      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {detail.billType === 1 &&
            User.checkAuth('10050304') &&
            quoteDetail.status === 1 && (
              <Button
                type="default"
                onClick={() => setReturnBottom(true)}
                className="m-flex-item u-btn u-btn_primary"
              >
                退回{config.quoteName}
              </Button>
            )}
        </div>
      )}
      {self.isPurchase &&
        detail.billType === 1 &&
        User.checkAuth('10050304') &&
        quoteDetail.status === 1 && (
          <Drawer
            anchor="bottom"
            open={returnBottom}
            onClose={() => setReturnBottom(false)}
          >
            <div tabIndex={0} role="button">
              <div className="MuiDrawer-paper">
                <div className="text-field-item">
                  <TextField
                    id="outlined-full-width"
                    error={isBackTxtError}
                    helperText={backHelperText}
                    label={'退回' + config.quoteName}
                    value={sendBackTxt}
                    onChange={event => handleQuoteChange('', event)}
                    margin="normal"
                    rows="3"
                    multiline
                    fullWidth
                    variant="outlined"
                  />
                </div>
                <p className="mt15 m-flex-box">
                  <Button
                    type="default"
                    onClick={() => handleRetrunQuote()}
                    className="m-flex-item u-btn u-btn_primary"
                  >
                    确定
                  </Button>
                  <Button
                    type="default"
                    onClick={() => setReturnBottom(false)}
                    className="m-flex-item u-btn u-btn_primary"
                  >
                    取消
                  </Button>
                </p>
              </div>
            </div>
          </Drawer>
        )}

      {!self.isPurchase && User.checkAuth('20050302') && (
        <Dialog
          open={quoteBottom}
          fullScreen={true}
          onClose={() => setQuoteBottom(false)}
        >
          <div tabIndex={0} role="button">
            <div className="MuiDrawer-paper">
              <div className="text-field-item">
                <TextField
                  label="报价数量"
                  value={thresholdEndQty || ''}
                  disabled={
                    detail.isSpecifyStepQuoteQty ||
                    currQuoteItem.status === 3 ||
                    !detail.vendorCanAdjustQuoteQty
                  }
                  onChange={event =>
                    handleQuoteChange('thresholdEndQty', event)
                  }
                  margin="normal"
                  variant="outlined"
                />
                {custCompanyParams[
                  'Inquiry_quantity_can_not_be_empty_config'
                ] === '1' && <i className="icon-required"></i>}
              </div>
              <div className="text-field-item">
                <TextField
                  label="报价单价"
                  value={quotePrice || ''}
                  onChange={event => handleQuoteChange('quotePrice', event)}
                  margin="normal"
                  variant="outlined"
                />
                <i className="icon-required"></i>
              </div>
              <div className="text-field-item">
                <TextField
                  label="承诺交期（天）"
                  value={promiseDeliDays || ''}
                  onChange={event =>
                    handleQuoteChange('promiseDeliDays', event)
                  }
                  margin="normal"
                  variant="outlined"
                />
                {detail.promisesDeliveryDateFlag === 1 && (
                  <i className="icon-required"></i>
                )}
              </div>
              <div className="text-field-item">
                <TextField
                  label="最小采购量"
                  value={minPurchaseQty || ''}
                  onChange={event => handleQuoteChange('minPurchaseQty', event)}
                  margin="normal"
                  variant="outlined"
                />
                {detail.minPurchaseQtyFlag === 1 && (
                  <i className="icon-required"></i>
                )}
              </div>
              <div className="text-field-item">
                <TextField
                  label="制造商料号"
                  value={manufacturerProdCode || ''}
                  onChange={event =>
                    handleQuoteChange('manufacturerProdCode', event)
                  }
                  margin="normal"
                  variant="outlined"
                />
                {detail.manufacturersPartNoFlag === 1 && (
                  <i className="icon-required"></i>
                )}
              </div>
              <div className="text-field-item">
                <TextField
                  label="品牌"
                  value={brandName || ''}
                  onChange={event => handleQuoteChange('brandName', event)}
                  margin="normal"
                  variant="outlined"
                />
                {detail.brandNameMustFlag === 1 && (
                  <i className="icon-required"></i>
                )}
              </div>
              <div className="text-field-item">
                <TextField
                  label="最小包装"
                  value={minPackage || ''}
                  onChange={event => handleQuoteChange('minPackage', event)}
                  margin="normal"
                  variant="outlined"
                />
                {detail.minPackageMustFlag === 1 && (
                  <i className="icon-required"></i>
                )}
              </div>
              <div className="text-field-item">
                <TextField
                  label="模具费用"
                  value={modelFee || ''}
                  onChange={event => handleQuoteChange('modelFee', event)}
                  margin="normal"
                  variant="outlined"
                />
                {detail.modelFeeFlag === 1 && <i className="icon-required"></i>}
              </div>
              {/* 单身自定义字段 */}
              {/* <BodydCustField
                isEdit={true}
                fieldSetting={fieldSetting}
                line={currQuoteItem}
                isPurchase={self.isPurchase}
                bodyCustData={bodyCustData}
                setBodyCustData={setBodyCustData}
              ></BodydCustField> */}
              {/* {!Util.isEmpty(extendList) &&
                extendList.map((extend, i) => (
                  <div className="text-field-item" key={extend.id + i}>
                    <TextField
                      label={extend.transName}
                      value={
                        extend.fieldCode === 'platformExtendN01'
                          ? platformExtendN01
                          : platformExtendN02
                      }
                      onChange={event =>
                        handleQuoteChange(extend.fieldCode, event)
                      }
                      margin="normal"
                      variant="outlined"
                    />
                    {extend.isRequiredField === 1 && (
                      <i className="icon-required"></i>
                    )}
                  </div>
                ))} */}
              <div className="text-field-item">
                <label className="order-detail-label">税别</label>
                <div
                  className="order-detail-value"
                  style={{
                    border: '1px solid',
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                    borderRadius: '4px'
                  }}
                >
                  <Select
                    value={taxCode || ''}
                    onChange={event => handleQuoteChange('taxCode', event)}
                    disabled={
                      (detail.isAccordingToVendor === 1 &&
                        !Util.isEmpty(detail.taxCode)) ||
                      detail.quoteLimitFlag !== 0
                    }
                    className="select-company-list"
                  >
                    {!Util.isEmpty(taxTypeList) &&
                      taxTypeList.map((item, index) => (
                        <MenuItem key={index} value={item.id}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Select>
                  <i className="icon-required"></i>
                </div>
              </div>

              <div className="text-field-item f-mt5">
                {/* 单身自定义字段 */}
                <BodydCustField
                  fieldSetting={fieldSetting1}
                  line={currQuoteItem}
                  bodyCustData={currQuoteItem}
                  setBodyCustData={setCurrQuoteItem}
                  isEdit={true}
                  isPurchase={self.isPurchase}
                ></BodydCustField>
              </div>

              <div className="text-field-item">
                <TextField
                  label="相关说明"
                  value={description || ''}
                  onChange={event => handleQuoteChange('description', event)}
                  margin="normal"
                  rows="3"
                  multiline
                  fullWidth
                  variant="outlined"
                />
              </div>
              <p className="mt15 m-flex-box">
                <Button
                  type="default"
                  onClick={() => sureQuoteClick()}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  确定
                </Button>
                <Button
                  type="default"
                  onClick={() => cancelQuoteClick()}
                  className="m-flex-item u-btn u-btn_line"
                >
                  取消
                </Button>
              </p>
            </div>
          </div>
        </Dialog>
      )}
      {!self.isPurchase && User.checkAuth('20050302') && (
        <div className="wrap m-flex-box fixed-bottom">
          {quoteEdit && (
            <Button
              type="default"
              onClick={() => handle('quoteSave')}
              className="m-flex-item u-btn u-btn_primary"
            >
              保存
            </Button>
          )}
          {quoteEdit && (
            <Button
              size="medium"
              type="default"
              onClick={() => handle('cancelSave')}
              className="m-flex-item u-btn u-btn_line"
            >
              取消
            </Button>
          )}
          {!quoteEdit &&
            quoteDetail.status === 0 &&
            detail.isSpecifyStepQuoteQty !== 1 && (
              <Button
                type="default"
                onClick={() => handle('editClick')}
                className="m-flex-item u-btn u-btn_primary"
              >
                编辑
              </Button>
            )}
          {!quoteEdit && quoteDetail.status === 0 && quoteDetail.quoXkNo && (
            <Button
              type="default"
              onClick={() => handle('handleConfirm')}
              className="m-flex-item u-btn u-btn_warn"
            >
              发送报价
            </Button>
          )}
        </div>
      )}
      {
        // 附件查看
        Array.isArray(fileList) && fileList.length > 0 && (
          <Download fileList={fileList} />
        )
      }
      <Modal></Modal>
    </div>
  );
}

InquiryQuoteDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InquiryQuoteDetail);
